/* eslint-disable */

function extract2(input_) {
  let ret = input_?.slice(0, -1);
  return (ret)? ret: "";
}

export {extract2};
